import { createPivotTransformer } from './create-pivot-transformer';

/** Pivot = m/s (linear velocity). */
export const VELOCITY_PIVOT: Record<string, number> = {
  'm/s': 1,
  'mm/s': 0.001,
  'in/s': 0.0254,
  'ft/s': 0.3048,
  mph: 0.44704,
  'km/h': 0.277778,
};

export const transformVelocity = createPivotTransformer(VELOCITY_PIVOT);
